/* Routes for the support area (Area C: account). Paths are relative; see src/app/routes.ts. */
import { page, type AreaRoutes } from '@/app/routes'

export const routes: AreaRoutes = {
  shell: [
    { path: 'support', lazy: page(() => import('./pages/SupportPage')) },
    { path: 'support/new', lazy: page(() => import('./pages/NewTicketPage')) },
    { path: 'support/:id', lazy: page(() => import('./pages/TicketPage')) },
  ],
}
